<!--
  @Description: 左侧导航
  @Author: wang.y 
  @Date: 2023-12-20 
-->
<template>
  <div class="home-nav-container">
    <Affix :offset-top="offset_top" @on-change="affixChange" id="home-nav-affix">
      <div class="data-nav" ref="home-nav-content" :style="'transform: translateY(' + translate_y + 'px);'">
        <div class="home-nav">
          <!-- <div class="logo" @click="handleClickItem(1)">
            <img :src="static_img_url+'pic/logo-vcbeat.png?v=922'">
          </div> -->
          <div class="nav-list">
            <div v-for="(item,index) in nav_list" :key="index">
              <div :class="['nav-item', item.disabled && 'disabled', current_id == item.id && 'on', item.hot && 'hot']" v-if="item.type == 1" @click="handleClickItem(item)">
                <i class="iconfont-pc30" v-if="item.id == 1">&#xe6d9;</i>
                <i class="iconfont-pc30" v-if="item.id == 2">&#xe6da;</i>
                <i class="iconfont-pc30" v-if="item.id == 3">&#xe6d8;</i>
                <i class="iconfont-pc30" v-if="item.id == 4">&#xe6d6;</i>
                <i class="iconfont-pc30" v-if="item.id == 5">&#xe6e8;</i>
                <i class="iconfont-pc30" v-if="item.id == 6">&#xe6db;</i>
                <span>{{item.name}}</span>
              </div>
              <div class="line" v-else></div>
            </div>
            <div class="line"></div>
            <div class="download-code">
              <img :src="static_img_url + 'pic/download-code.png'" />
              <p>动脉网APP<br />扫码下载</p>
            </div>
          </div>
        </div>
      </div>
    </Affix>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  components: {},
  beforeMount() {
    let r_name = this.$route.name
    if (r_name == 'LiveTheme') this.current_id = 5
    if (r_name == 'Live') this.current_id = 6
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollChange()
    })
  },
  data() {
    return {
      current_id: 0,
      nav_list: [
        { id: 1, disabled: 0, type: 1, name: '首页' },
        { id: 2, disabled: 0, type: 1, name: '情报' },
        { id: 0, disabled: 0, type: 2, name: '' },
        { id: 3, hot: true, disabled: 0, type: 1, name: '原创' },
        { id: 4, disabled: 0, type: 1, name: '发现' },
        { id: 5, disabled: 0, type: 1, name: '专题' },
        { id: 0, disabled: 0, type: 2, name: '' },
        { id: 6, disabled: 0, type: 1, name: '直播' },
        { id: 0, disabled: 0, type: 2, name: '' },
        { id: 7, disabled: 0, type: 1, name: 'ENGLISH' },
      ],
      offset_top: 0,
      translate_y: 0,
      is_affix: false,
      init_top: 20,
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      index_path: (state) => state.index_path,
      index2_path: (state) => state.index2_path,
    }),
  },
  methods: {
    handleClickItem(row) {
      if (row.disabled) return
      let href
      if (row.id == 1) {
        href = this.index2_path + '/new'
        window.location.href = href
      } else if (row.id == 2) {
        href = this.index2_path + '/intelList'
        window.open(href, '_blank')
      } else if (row.id == 3) {
        href = this.index2_path + '/articleList'
        window.open(href, '_blank')
      } else if (row.id == 4) {
        href = this.index2_path + '/intelDiscoverList'
        window.open(href, '_blank')
      } else if (row.id == 5) {
        href = this.index_path + '/liveTheme?type=0'
        window.open(href, '_blank')
      } else if (row.id == 6) {
        href = this.index_path + '/live'
        window.open(href, '_blank')
      } else if (row.id == 7) {
        href = 'http://i.vbdata.cn/'
        window.open(href, '_blank')
      }
    },
    scrollChange() {
      let footer_height = document.getElementById('home-footer').offsetHeight
      let header_height = document.getElementById('home-header').offsetHeight
      let scroll_top = document.documentElement.scrollTop || document.body.scrollTop //滚动条的值
      let y = scroll_top + window.innerHeight + footer_height - document.body.clientHeight
      this.translate_y = y > -1 ? 0 - y : 0

      let num = window.innerHeight - this.$refs['home-nav-content'].offsetHeight - 20
      this.offset_top = num > header_height ? header_height + this.init_top : num
      let affix_dom = document.querySelector('#home-nav-affix .ivu-affix')
      if (!affix_dom) return
      if (this.is_affix) {
        affix_dom.style.top = this.offset_top + 'px'
        affix_dom.style.left = 'auto'
      } else {
        affix_dom.style.top = 'auto'
        affix_dom.style.left = 'auto'
      }
    },
    affixChange(val) {
      this.is_affix = val
    },
  },
}
</script>
<style lang='stylus' scoped>
.home-nav-container
  width 126px
  .data-nav
    >div
      margin-top 30px
    >div:nth-child(1)
      margin-top 0
  .ivu-affix
    left auto !important
.home-nav
  background #FFFFFF
  width 126px
  .logo
    width 100%
    cursor pointer
    img
      width 100%
  .nav-list
    // margin-top 10px
    // border-top 1px solid #EEEEEE
    // padding 20px 0
    > div
      width 100%
    .line
      width 66px
      height 1px
      background #EEEEEE
      margin 10px auto
    .download-code
      display flex
      flex-direction column
      align-items center
      img
        width 80px
        height 80px
        font-size 0
      p
        font-weight 400
        color #FF8824
        line-height 20px
        margin-top 5px
        font-size 14px
        text-align center
    .nav-item
      width 100%
      display flex
      height 46px
      display flex
      justify-content center
      align-items center
      transition all 0.3s
      color #333333
      cursor pointer
      background-color #FFFFFF
      border-radius 4px
      .iconfont-pc30, span
        font-size 16px
        line-height 1
      .iconfont-pc30 + span
        margin-left 10px
      &.hot
        color #FF8824
      &.on, &:hover
        background-color #FFF8F2
        color #FF8824
      &.disabled
        background-color #FFFFFF
        color #999999
        cursor not-allowed
</style>